import React from "react"
import parentStyles from "../styles.css"
import styles from "./styles.css"
import PropTypes from "prop-types"

const InputField = ({ formik, formValues }) => {
  const { name, placeholder, isDisabled } = formValues
  const { touched, values, errors, handleBlur } = formik
  const isErrorField = touched[name] && errors[name]

  const handleChange = (name, value) => {
    formik.setFieldValue(name, value, true)

    const updatedErrors = { ...errors }

    if (updatedErrors[name]) {
      delete updatedErrors[name]
      formik.setErrors(updatedErrors)
    }
  }

  return (
    <div className={parentStyles.line}>
      <div className={styles.input_field}>
        <input
          id={name}
          name={name}
          type="text"
          disabled={isDisabled}
          placeholder={placeholder}
          className={`${isErrorField && parentStyles.focus_error}`}
          onChange={(e) => {
            handleChange(e.target.name, e.target.value)
          }}
          value={values[name]}
          onBlur={handleBlur}
        />
        {isErrorField && (
          <div className={parentStyles.error}>{errors[name]}</div>
        )}
      </div>
    </div>
  )
}

InputField.propTypes = {
  formik: PropTypes.object,
  formValues: PropTypes.object
}

export default InputField



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/InputField/index.js